.suggestions {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    align-items: flex-end;

    &__button {
        white-space: nowrap;
        text-overflow: ellipsis;
        background-color: #f0ebe5;
        border: 2px solid transparent;
        border-radius: 12px;
        max-width: 100%;
        padding: 8px 14px;
        overflow: hidden;
        margin-bottom: 10px;
        margin-right: 10px;
        transition:
            background-color 0.3s ease,
            border-color 0.3s ease,
            box-shadow 0.3s ease,
            transform 0.2s ease;

        &:hover {
            cursor: pointer;
            background-color: #fff;
            border-color: #ff383c;
            box-shadow: 0 4px 12px rgba(255, 56, 60, 0.3);
            transform: translateY(-2px);
        }

        &:disabled {
            background-color: #cccccc;
            cursor: not-allowed;
            transform: none;
            box-shadow: none;
        }
    }

    @media screen and (min-width: 768px) {
        flex-direction: row;
    }
}